import { hotPropertyApi, homepageImageApi } from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { homeActions } from "./actions";

export function* homeSaga() {
    yield takeEveryFsa(homeActions.hotPropertyies.started, function* (action) {
        yield* makeAsyncApiCall(action, homeActions.hotPropertyies, hotPropertyApi);
    })
    yield takeEveryFsa(homeActions.homepageImage.started, function* (action) {
        yield* makeAsyncApiCall(action, homeActions.homepageImage, homepageImageApi);
    })
}
